import React from 'react';
import {
  UploadProps as AntdUploadProps,
  DraggerProps as AntdDraggerProps,
} from 'antd/lib/upload';
import {
  StyledUpload,
  StyledDragger,
  StyledIcon,
  StyledHeader,
  StyledTitle,
  StyledDescription,
} from './StyledComponents';

type CommonProps = {
  header?: string;
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  showIcon?: boolean;
};

export const Upload: React.FC<AntdUploadProps & CommonProps> = ({
  title,
  description,
  icon = <StyledIcon type="antdInboxOutlined" color="primary" width={48} />,
  showIcon,
  openFileDialogOnClick = true,
  children,
  ...props
}) => (
    <StyledUpload {...props} openFileDialogOnClick={openFileDialogOnClick}>
      {showIcon && icon}
      {title && <StyledTitle textAlign="center">{title}</StyledTitle>}
      {description && (
        <StyledDescription type="secondary" textAlign="center">
          {description}
        </StyledDescription>
      )}
      {children}
    </StyledUpload>
  );

export const Dragger: React.FC<AntdDraggerProps & CommonProps> = ({
  header,
  title,
  description,
  icon = <StyledIcon type="antdInboxOutlined" color="primary" width={48} />,
  showIcon,
  openFileDialogOnClick = true,
  children,
  ...props
}) => (
    <StyledDragger {...props} openFileDialogOnClick={openFileDialogOnClick}>
      {header && (
        <StyledHeader strong textAlign="center">
          {header}
        </StyledHeader>
      )}
      {showIcon && icon}
      {title && <StyledTitle textAlign="center">{title}</StyledTitle>}
      {description && (
        <StyledDescription type="secondary" textAlign="center">
          {description}
        </StyledDescription>
      )}
      {children}
    </StyledDragger>
  );

export {
  UploadFile as UploadFileType,
  UploadChangeParam as UploadChangeParamType,
} from 'antd/lib/upload/interface';
